import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Unit } from "../../types/estate";
import "./units.scss";
import {
    cleanSlug,
    fetchFileData,
    fetchImageData,
} from "../../helpers/helpers";
import { useState, useEffect } from "react";
import { gsap } from "gsap-trial";
import axios from "axios";
import Carousel from "../../components/swiper/swiper";

const Units = () => {
    const { slug } = useParams();
    const location = useLocation();
    const [unit, setUnit] = useState<Unit | null>(null);
    const [images, setImages] = useState<string[]>([]);
    const [icons, setIcons] = useState<string[]>([]);
    const [middleSegment, setMiddleSegment] = useState<string>("");

    const [floorplan, setFloorplan] = useState<any>("");
    useEffect(() => {
        const getMiddlePathSegment = (pathname: string) => {
            const segments = pathname.split("/");

            return segments.length > 2 ? segments[2] : "";
        };

        const segment = getMiddlePathSegment(location.pathname);
        setMiddleSegment(segment);
        const fetchArticle = async () => {
            try {
                const response = await axios.get(
                    `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed&slug=${segment}`
                );
                if (response.data.length > 0) {
                    console.log("Response", response.data[0]);
                    response.data[0].acf.units?.map((unit: Unit) => {
                        if (cleanSlug(unit.name) === slug) {
                            console.log("Unit", unit);
                            setUnit(unit);
                            console.log("Unit", unit);
                        }
                    });
                } else {
                }
            } catch (err) {
            } finally {
            }
        };
        fetchArticle();
    }, []);

    useEffect(() => {
        // const fetchImages = async () => {
        //     if (unit?.images) {
        //         unit.images.map((image) => {
        //             console.log(image);
        //         });
        //         const imagePromises = unit.images.map((image) =>
        //             fetchImageData(String(image.image))
        //         );

        //         if (imagePromises) {
        //             const resolvedImages = await Promise.all(imagePromises);
        //             setImages(resolvedImages);
        //             console.log(resolvedImages);
        //         }
        //     }
        // };

        if (unit) {
            // fetchImages();

            gsap.fromTo(
                ".opacity-anim",
                { opacity: 0 },
                { opacity: 1, duration: 1, ease: "power2.out" }
            );
            gsap.fromTo(
                ".units-three",
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
                {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    duration: 1.5,
                    ease: "power2.out",
                }
            );
        }
        // const fetchIcons = async () => {
        //     if (unit?.specification) {
        //         const iconPromises = unit.specification.map((spec) =>
        //             fetchImageData(spec.icon)
        //         );
        //         const resolvedIcons = await Promise.all(iconPromises);
        //         setIcons(resolvedIcons);
        //     }
        // };
        // fetchIcons();
    }, [unit]);

    const downloadBrochure = () => {
        if (unit?.downloads && unit?.downloads[0].brochure) {
            const link = document.createElement("a");
            link.href = unit?.downloads[0]?.brochure.link || "";
            link.setAttribute("download", "");
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        if (unit?.downloads && unit?.downloads[0].floorplans) {
            const link = document.createElement("a");
            link.href = unit?.downloads[0]?.floorplans.link || "";
            link.setAttribute("download", "");
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="units-hero">
            <div className="contain-wrapper">
                <div className="units-one contain opacity-anim">
                    <div className="wrapper">
                        <p>
                            Home / <span className="volt">Property</span>
                        </p>
                    </div>
                    <div className="second-wrapper">
                        {unit?.downloads[0]?.brochure && (
                            <a
                                href={unit?.downloads[0]?.brochure.link}
                                target="blank"
                                className="volt-button"
                            >
                                <p>Download Brochure</p>
                            </a>
                        )}
                        <Link
                            target="_top"
                            className="volt-button"
                            to={"/portfolio"}
                        >
                            <p>View all properties</p>
                        </Link>
                    </div>
                </div>
            </div>
            {unit && (
                <>
                    <div className="contain-wrapper">
                        <div className="units-two contain opacity-anim">
                            <div className="wrapper">
                                <img
                                    src="/ui/logo.svg"
                                    className="logo"
                                    alt="logo"
                                />
                                <h1>{unit.full_name}</h1>
                            </div>
                            <div className="wrapper-two">
                                <div className="h3-container">
                                    <h3>{unit.sq_ft} sq ft</h3>
                                    <h3>{unit.name}</h3>
                                    <h3>{unit.full_address}</h3>
                                </div>
                                <div className="p-container">
                                    <p>{unit.unit_type}</p>
                                    <p className="volt">{unit.let_status}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contain-wrapper">
                        <div className="units-three contain">
                            <Link
                                target="_top"
                                className="learn-more opacity-anim"
                                to={`/portfolio/${middleSegment}`}
                            >
                                <p>Learn more about the estate</p>
                                <img
                                    src="/ui/left-arrow.svg"
                                    alt="left-arrow"
                                />
                            </Link>
                            {unit.images.length > 1 ? (
                                <Carousel
                                    images={unit.images.map(
                                        (image) => image.image
                                    )}
                                />
                            ) : (
                                <div className="image-wrapper">
                                    <img src={unit.images[0].image} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="contain-wrapper">
                        <div className="units-four contain">
                            {unit.description && (
                                <div className="wrapper">
                                    <p className="volt">Description</p>
                                </div>
                            )}
                            <div className="wrapper">
                                {unit.description && (
                                    <div
                                        className="wysiwyg description"
                                        dangerouslySetInnerHTML={{
                                            __html: unit.description,
                                        }}
                                    />
                                )}
                                <Link
                                    target="_top"
                                    to={`/map?lat=${unit.map_location[0].lat}&lng=${unit.map_location[0].long}&zoom=15`}
                                    state={{ zoom: 12 }}
                                    className="inline-copy"
                                >
                                    <p className="volt">View on the map</p>
                                    <div className="parallelogram-small"></div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="contain-wrapper">
                        <div className="units-four contain">
                            {unit.specification && (
                                <div className="wrapper">
                                    <p className="volt">Specification</p>
                                </div>
                            )}
                            <div className="icons-wrapper">
                                {unit.specification &&
                                    unit.specification?.map(
                                        (specification: any, index: any) => (
                                            <div
                                                key={index}
                                                className="icon-wrapper"
                                            >
                                                <img
                                                    src={
                                                        specification.icon.link
                                                    }
                                                />
                                                <p>
                                                    {specification.icon_label}
                                                </p>
                                            </div>
                                        )
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="contain-wrapper">
                        {unit.downloads[0] && (
                            <div className="units-four contain">
                                <div className="wrapper">
                                    {(unit?.downloads[0]?.brochure ||
                                        unit.downloads[0].floorplans) && (
                                        <p className="volt">Downloads</p>
                                    )}
                                </div>
                                <div className="wrapper">
                                    {unit?.downloads[0]?.brochure && (
                                        <a
                                            href={
                                                unit.downloads[0].brochure.link
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                            className="inline-copy"
                                        >
                                            <h4 className="volt">Brochure</h4>
                                            <p>
                                                (
                                                {(
                                                    unit.downloads[0].brochure
                                                        .filesize /
                                                    (1024 * 1024)
                                                ).toFixed(2)}
                                                mb)
                                            </p>
                                        </a>
                                    )}
                                    {unit.downloads[0].floorplans && (
                                        <>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                className="inline-copy"
                                                href={
                                                    unit.downloads[0].floorplans
                                                        .link
                                                }
                                            >
                                                <h4 className="volt">
                                                    Floor Plan
                                                </h4>
                                                <p>
                                                    (
                                                    {unit.downloads[0]
                                                        .floorplans.filesize
                                                        ? (
                                                              unit.downloads[0]
                                                                  .floorplans
                                                                  .filesize /
                                                              (1024 * 1024)
                                                          ).toFixed(2)
                                                        : "0.00"}
                                                    mb)
                                                </p>
                                            </a>
                                        </>
                                    )}
                                    {unit.downloads[0].floorplans &&
                                        unit.downloads[0].brochure && (
                                            <a onClick={downloadBrochure}>
                                                <h4 className="volt">
                                                    Download All
                                                </h4>
                                            </a>
                                        )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="contain-wrapper">
                        <div className="units-four last contain">
                            {unit.contacts && (
                                <div className="wrapper">
                                    <p className="volt">Get in touch</p>
                                </div>
                            )}
                            <div className="wrapper">
                                <div className="agents">
                                    {unit.contacts &&
                                        unit.contacts?.map(
                                            (
                                                contact: {
                                                    name: string;
                                                    email_address: string;
                                                    phone_number: string;
                                                },
                                                index: number
                                            ) => (
                                                <div className="agent">
                                                    <p>{contact.name}</p>
                                                    <a
                                                        href={`tel:${contact.phone_number}`}
                                                    >
                                                        <p>
                                                            {
                                                                contact.phone_number
                                                            }
                                                        </p>
                                                    </a>
                                                    <a
                                                        href={`mailto:${contact.email_address}`}
                                                    >
                                                        <p className="volt">
                                                            {
                                                                contact.email_address
                                                            }
                                                        </p>
                                                    </a>
                                                </div>
                                            )
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Units;
